export * from './magic-link-login-page.component';
export * from './magic-link-login-page.module';
